import { useSelector } from "react-redux";
import "../CSS/navBar.css"
import { useState } from "react";


const NavBar = ({ isPencil, isEditMode, handleEditClick, profilePhoto }) => {
    const defaultProfilePhoto = "/webdp.gif";
    const loginInfo = useSelector((state) => state.login);
    const profilePhotoFinal = profilePhoto || loginInfo.profile_pic || defaultProfilePhoto;
    const [isDarkMode , setIsDarkMode] = useState(true)


    const handleDarkMode = (event) => {
        const { checked } = event.target
        if (checked) {
            // document.body.classList.add('dark');
            document.getElementById("dashboard").classList.remove("dark")
            setIsDarkMode(false)
        } else {
            document.getElementById("dashboard").classList.add("dark")
            setIsDarkMode(true)
        }
    }

    return (
        <nav>
            <div className="nav row">
               {/* {isDarkMode && <img src="/sun.gif" width="40" height="40" />} */}
                <input
                    type="checkbox"
                    id="switch-mode"
                    style={{ display: "none" }}
                    onChange={handleDarkMode}
                />
                <label htmlFor="switch-mode" className="switch-mode"></label>
                {/* {!isDarkMode && <img src="/night.gif" width="40" height="40"/> } */}

                <img
                    className="mypro-DPimage"
                    src={profilePhotoFinal}
                    alt="Profile"
                />
                {isPencil && !isEditMode && (
                    <img
                        src="/pencil.gif"
                        alt="Edit"
                        onClick={handleEditClick}
                        className="mypro-icon-button"
                    />
                )}
            </div>
        </nav>
    )
}

export default NavBar;